<section [ngClass]="{ 'container-fluid' : !(isMobile | async) }">
  <div *ngIf="!isLoading" class="container py-5">
    <div class="row mb-3 mt-3">
      <div class="col-md-5">
        <ul *ngIf="selectedSchool == null" class="nav flex-column nav-pills" id="v-pills-tab">
          <ng-container *ngFor="let school of schools | async">
            <li class="nav-link shadow-sm mb-2 bg-white" [class.py-3]="isMobile | async"
              (click)="filterDirectory(school.name)">{{ school.name }}</li>
          </ng-container>
        </ul>

        <ul *ngIf="selectedSchool != null" class="nav flex-column nav-pills" id="v-pills-tab">
          <ng-container *ngFor="let department of departments | async">
            <li class="nav-link shadow-sm mb-1 bg-white" [class.py-3]="isMobile | async"
              (click)="filterDirectory(selectedSchool, department.name)">
              {{ department.name }}</li>
          </ng-container>
        </ul>

        <button *ngIf="selectedDepartment != null" (click)="clearDepartment()">
          <fa-icon [icon]="faAngleDoubleLeft"></fa-icon> Back
        </button>
        <button *ngIf="selectedDepartment == null && selectedSchool != null" (click)="clearSchool()">
          <fa-icon [icon]="faAngleDoubleLeft"></fa-icon> Back
        </button>
      </div>

      <div class="col-md-7 d-flex flex-column">
        <div class="shadow-sm p-2 bg-white profile-list" [ngClass]="{ 'mt-3' : isMobile | async }">
          <ng-container *ngFor="let profile of profiles | async | sortBy : 'asc':'lastname'">
            <div class="row p-2 mx-2 mb-2 d-flex justify-content-between align-items-end profile-list-item">
              <div class="col-10">
                <ul class="list-unstyled mb-0">
                  <li>{{ profile.firstname }} {{ profile.lastname }}</li>
                  <li><small [innerHTML]="profile.position"></small></li>
                  <li><small [innerHTML]="profile.rank"></small></li>
                </ul>
              </div>
              <div class="col-2 d-flex justify-content-end">
                <button type="button" class="btn btn-outline-secondary" [class.btn-sm]="!(isMobile | async)"
                  [routerLink]="['/profile', profile.id]">View</button>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>

  <ng-container *ngIf="isLoading">
    <div class="container py-5">
      <div class="row">
        <div class="col-md-5">
          <ngx-skeleton-loader count="6" [theme]="{ 'background-color': '#fafafa', 'padding': '15px' }">
          </ngx-skeleton-loader>
        </div>
        <div class="col-md-7">
          <ngx-skeleton-loader count="10" [theme]="{ 'background-color': '#fafafa', 'padding': '15px' }">
          </ngx-skeleton-loader>
        </div>
      </div>
    </div>
  </ng-container>
</section>